import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { DropTarget } from 'react-dnd'
import ItemTypes from '../constants/ItemTypes'
import Box from './Box'
import LegendDto from '../../../administration/dto/LegendDto'
import { connect } from 'react-redux'

class Dustbin extends Component {
	constructor(props) {
		super(props)
	}

	getBox(box) {
		return (
			<Box key={ `box${box.id}` } id={ box.id } hideSourceOnDrag={ true } top={ this.props.top }
				 left={ this.props.left } onDrag={ this.props.onRemoveBox }>
				{ box.children }
			</Box>
		)
	}

	getButtonStyle = () => {
		return {
			position: 'relative',
			top: 20,
			zIndex: '10'
		}
	}

	getContent(boxes) {
		return boxes.map(o => (
			<div className={ 'no-padding no-margin' }>
				<div className={ 'right-align' } style={ this.getButtonStyle() }>
					<i className='material-icons' style={ { color: 'red' } }
					   onClick={ () => this.props.onRemoveBox(o.id) }>clear</i>
				</div>
				{ this.getBox(o) }
			</div>
		))
	}

	render() {
		const { connectDropTarget, boxes } = this.props
		if (boxes.length) {
			return connectDropTarget(
				<div>
					{ this.getContent(boxes) }
				</div>
			)
		}
		return null
	}
}

Dustbin.propTypes = {
	connectDropTarget: PropTypes.func.isRequired,
	isOver: PropTypes.bool.isRequired,
	canDrop: PropTypes.bool.isRequired,
	onAddBox: PropTypes.func.isRequired,
	onRemoveBox: PropTypes.func.isRequired,
	boxes: PropTypes.node.isRequired,
	left: PropTypes.number.isRequired,
	top: PropTypes.number.isRequired,
	legends: PropTypes.arrayOf(PropTypes.instanceOf(LegendDto))
}
const mapStateToProps = store => {
	return {
		legends: store.AdministrationReducer.legends
	}
}
const dustbinTarget = {
	drop(props, monitor) {
		const boxes = monitor.getItem().boxes
		if (boxes && boxes.length) {
			boxes.forEach(b => props.onAddBox(b))
		}
		props.onDrop(monitor.getItem())
	}
}

const collect = (connectDrag, monitor) => {
	return {
		connectDropTarget: connectDrag.dropTarget(),
		isOver: monitor.isOver(),
		canDrop: monitor.canDrop()
	}
}
const dropTarget = DropTarget([ItemTypes.DUSTBIN_BOX, ItemTypes.BOX], dustbinTarget, collect)(Dustbin)

export default connect(mapStateToProps)(dropTarget)



// WEBPACK FOOTER //
// ./src/components/drag/components/Dustbin.js